import { cr } from "fire-wind-water";

// dirty: boolean;  // 字段值是否被主动修改过
// invalid: boolean;  // 字段值是否无效
// disabled: boolean;  // 字段禁用
// value: any;   // 字段提交值
// model: any;   // 提交值的详细信息
// validationMessage: string;  // 错误提示
// error: any;   // 错误集合
// messages: any;  // 错误提示集合
//
// fieldName: string;   // 字段英文名
// displayName: string;  // 字段中文名
// fieldType: string;  // 字段类型
// required: number;   // 是否必填
// repeat: number;     // 是否验证重复
// errorMessage: string;  // 正则验证错误的提示
// textLength: number;  // 字段允许输入最大值
//
// errorCustom: any[];   // 自定义错误集合
// errorAsync: any[];   // 自定义异步校验错误
// asyncStatus: { [label: string]: string };    // 异步校验状态
// dt: any = null;     // 自定义错误延迟验证定时器
// InitialValue: any = null;  // 字段回填值

class Field {
  fieldName: string;
  displayName: string;
  isSendSms: any;
  fieldInfo: { [label: string]: any };

  protected dirty = false;
  protected invalid = true;
  disabled: boolean;
  value: any;
  model: any;
  validationMessage: string;

  error: { [label: string]: boolean };
  messages: { [label: string]: string };
  errorMessage = "";
  textLength: number;

  errorCustom: unknown[] = [];
  errorAsync: unknown[] = [];
  asyncStatus: { [label: string]: string } = {};

  InitialValue: unknown;
  dt: any;
  required: any;

  constructor(field) {
    this.fieldInfo = field;
    const attr = [
      "fieldName",
      "displayName",
      "displayType",
      "fieldType",
      "fieldLevel",
      "required",
      "repeat",
      "errorMessage",
      "textLength",
      "placeholder",
      "isSendSms",
    ];
    cr.each(attr, (d) => {
      this[d] = field[d];
    });
    if (this.fieldName !== "mobile") {
      this.isSendSms = 0;
    }
    this.disabled = !!field.disabled;
    this.initError();
  }

  setDisabled(): void {
    this.disabled = true;
  }

  setEnable(): void {
    this.disabled = false;
  }

  initError(): void {
    this.error = {
      required: false,
      pattern: false,
      maxLength: false,
      number: false,
      repeat: false,
    };
    this.messages = {
      required: this.fieldInfo.errorRequired || "请选择" + this.displayName,
      pattern: this.errorMessage || "请输入正确的" + this.displayName,
      number: this.fieldInfo.errorNumber || "请输入数字",
      maxLength:
        this.fieldInfo.errorMaxLength || "输入长度不超过" + this.textLength,
      sendCode: this.fieldInfo.errorSendCode || "请输入手机号",
    };
    this.errorCustom = [];
    this.errorAsync = [];
    this.asyncStatus = {};
  }

  setMessageText(o: any): void {
    cr.extend(true, this.messages, o);
  }

  setError(): void {
    this.invalid = false;
    this.validationMessage = "";
    cr.each(this.error, (d, i) => {
      this.error[i] = false;
    });
  }

  setCustomError(o: { [label: string]: any }): void {
    this.error[o.key] = o.value || false;
    this.messages[o.key] = o.message;
    this.errorCustom.push(o);
  }

  hasCustomError(): void {
    cr.each(this.errorCustom, (d) => {
      if (d.validator) {
        const inval = d.validator(this);
        this.error[d.key] = !inval;
        if (!inval) {
          this.invalid = true;
        }
      }
    });
  }

  setAsyncError(o: { [label: string]: any }): void {
    this.error[o.key] = o.value || false;
    this.messages[o.key] = o.message;
    this.asyncStatus[o.key] = "";
    this.errorAsync.push(o);
  }

  hasAsyncError(): void {
    if (!this.dirty || this.InitialValue === this.value) {
      return;
    }
    cr.each(this.errorAsync, (d: any): void => {
      if (d.validator) {
        this.asyncStatus[d.key] = "pending";
        const inval = d.validator(this);
        inval.then(
          (result) => {
            this.asyncStatus[d.key] = "";
            this.error[d.key] = !result;
            if (!result) {
              this.invalid = true;
              this.validationMessage = this.messages[d.key];
            }
          },
          (error) => {
            this.asyncStatus[d.key] = "error";
            return error;
          }
        );
      }
    });
  }

  hasError(): void {
    this.invalid = false;
    this.validationMessage = "";
    this.hasCustomError();
    cr.each(this.error, (d, t) => {
      if (d) {
        this.invalid = true;
        if (!this.validationMessage) {
          this.validationMessage = this.messages[t];
        }
      }
    });
    // 只有前面验证通过了，再去走异步校验
    if (!this.invalid) {
      clearTimeout(this.dt);
      this.dt = setTimeout(() => {
        if (!this.invalid) {
          this.hasAsyncError();
        }
      }, this.fieldInfo.timeout || 500);
    }
  }
}

export { Field };
